<template>
  <div class="o-modal-backdrop" @click.self="close" v-if="modalOpen">
    <div class="o-modal" @click.stop>
      <span class="o-modal-close" @click="close">
        &times;
      </span>
      <div class="mb-4">
        <h1 class="mt-0 mb-0">Contact us</h1>
      </div>
      <div class="mb-4">
        <label>Name</label>
        <input
          type="text"
          class="form-control"
          v-model="name"
          :disabled="loading"
        />
      </div>
      <div class="mb-4">
        <label>E-mail</label>
        <input
          type="email"
          class="form-control"
          v-model="email"
          :disabled="loading"
        />
      </div>
      <div class="mb-4">
        <label>Message</label>
        <textarea
          class="form-control"
          v-model="message"
          :disabled="loading"
          maxlength="255"
        ></textarea>
      </div>
      <button
        class="btn btn-lg btn-primary w-100"
        :disabled="!isFormValid"
        @click="submit"
      >
        <span v-if="loading">Sending...</span>
        <span v-else>Submit</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalOpen: false,
      name: "",
      email: "",
      message: "",
      loading: false,
    };
  },
  computed: {
    isFormValid() {
      if (this.loading) return false;
      return (
        this.name.trim() !== "" &&
        this.email.trim() !== "" &&
        this.message.trim() !== ""
      );
    },
  },
  methods: {
    submit() {
      let url = "https://www.ooyyo.com/ooyyo-services/resources/mail/contact";
      this.loading = true;
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: this.name,
          message: this.message,
          email: this.email,
          subject: "INVESTMENT",
        }),
      })
        .then((data) => data.json())
        .then((data) => {
          console.log(data);
          this.name = "";
          this.email = "";
          this.message = "";
          alert("Message successfully sent.");
        })
        .catch((err) => {
          console.log(err);
          alert("Something went wrong");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open() {
      document.querySelector("body").classList.add("modal-open");
      this.modalOpen = true;
    },
    close() {
      document.querySelector("body").classList.remove("modal-open");
      this.modalOpen = false;
    },
  },
};
</script>
